import ResetPasswordPresentation from './components/ResetPasswordPresentation';

export const ResetPasswordPage = (): JSX.Element => {
    return (
        <ResetPasswordPresentation/>
    )
};